export const ZendeskUrl = 'https://hellosagehelp.zendesk.com/hc/en-us';
export const NotificationsNotSupportedHelpUrl =
    'https://hellosagehelp.zendesk.com/hc/en-us/articles/9528541983245';
export const SageSupportPhoneNumber = '+18563297813';
export const SageSupportEmail = 'support@sagehealth.com';
